import { Component, Input, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {AddressService} from "../../../../services/address.service";
import {ApiService} from "../../../../services/api.service";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
})
export class AddressFormComponent implements OnInit {

  @Input() size: 'small' | 'large' = 'small';
  @Input() type: 'edit' | 'create' = 'create';
  @Input() formGroupName: string;
  form: FormGroup;
  $searching: BehaviorSubject<boolean>;
  $errorMessage: BehaviorSubject<string>;
  postCodeCountry: BehaviorSubject<string>;
  postCodeResults: BehaviorSubject<any[]>;

  addressLookup: FormGroup;
  postcodeLookup: FormGroup;

  view: 'initial' | 'select' | 'manual' | '' = '';
  postcodeType: 'UK' | 'Jersey' = 'UK';

  constructor(private rootFormGroup: FormGroupDirective, public fb: FormBuilder, public address: AddressService, public api: ApiService) {
    this.$searching = new BehaviorSubject<boolean>(false);
    this.$errorMessage = new BehaviorSubject<string>('');
    this.postCodeCountry = new BehaviorSubject<string>('');
    this.postCodeResults = new BehaviorSubject<any[]>([]);
    this.postcodeLookup = this.fb.group({
      postcode: [null, Validators.required]
    })
    this.addressLookup = this.fb.group({
      address: [null, Validators.required]
    })
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    if(this.type === 'create'){
      this.view = 'manual';
    }else{
      this.view = 'manual';
    }
  }

  enterManual(){
    this.form.reset();
    this.view = 'manual';
  }

  resetSearch(){
    this.view = 'initial';
  }

  determineSize(){
    if(this.size === 'small'){
      return 'col-6';
    }else{
      return 'col-12';
    }
  }

  doPostcodeLookup(){

    if(this.postcodeLookup.valid){
        this.$searching.next(true);
        this.api.apiPost('/api/meta/uk-postcode',this.postcodeLookup.value).then((PostCodeResult)=>{
          this.$errorMessage.next('');
          this.postCodeCountry.next(PostCodeResult.DetectedCountry);
          this.postCodeResults.next(PostCodeResult.Results.addresses);
          this.$searching.next(false);
          this.view = 'select';
        }).catch((err)=>{
          this.$errorMessage.next('The postcode is either invalid or not found');
        });
    }

  }

  doPostcodeLookupJersey(){

    if(this.addressLookup.valid){
        this.$searching.next(true);
        this.api.apiPost('/api/meta/jersey-postcode',this.addressLookup.value).then((PostCodeResult)=>{
          this.$errorMessage.next('');
          this.postCodeCountry.next(PostCodeResult.DetectedCountry);
          this.postCodeResults.next(PostCodeResult.Results.addresses);
          this.$searching.next(false);
          this.view = 'select';
        }).catch((err)=>{
          this.$errorMessage.next('The postcode is either invalid or not found');
        });
    }

  }

  selectAddress(address: any){

    this.view = 'manual';

    if(this.postCodeCountry.getValue() === 'Jersey'){
      this.mapJerseyAddress(address);
    }else{
      this.mapUKAddress(address);
    }

  }

  mapJerseyAddress(address: any){

    if(address.road){
      this.form.controls['address_line_1'].setValue(address.road);
    }

    if(address.parish){
      this.form.controls['town'].setValue(address.parish);
    }

    if(address.building){
      this.form.controls['building_name'].setValue(address.building);
    }

    if(address.locationOnStreet && !address.subElementDesc){
      this.form.controls['house_number'].setValue(address.locationOnStreet);
    }

    if(address.subElementDesc && !address.locationOnStreet){
      this.form.controls['house_number'].setValue(address.subElementDesc);
    }
    this.form.controls['country'].setValue('Jersey');
    //this.form.controls['postcode'].setValue(postcode.postcode);


  }

  mapUKAddress(address: any){

      const postcode = JSON.parse(JSON.stringify(this.postcodeLookup.value));

      if(address.building_name){
        this.form.controls['building_name'].setValue(address.building_name);
      }
      if(address.building_number){
        this.form.controls['house_number'].setValue(address.building_number);
      }
      if(address.thoroughfare){
        this.form.controls['address_line_1'].setValue(address.thoroughfare);
      }
      if(address.town_or_city){
        this.form.controls['town'].setValue(address.town_or_city);
      }
      if(address.county){
        this.form.controls['county'].setValue(address.county);
      }
      if(address.country){
        this.form.controls['country'].setValue(address.country);
      }

      this.form.controls['postcode'].setValue(postcode.postcode);

  }

}
